import React from "react";
import PT from "prop-types";
import "./input.m.css";

export function InputField({
  name,
  placeholder,
  type = "text",
  value,
  required,
  ...props
}) {
  return (
    <React.Fragment>
      <label htmlFor={name} className="sr-only">
        {name}
      </label>
      <input
        type={type}
        placeholder={placeholder || name}
        value={value}
        required={required}
        {...props}
        styleName="input"
      />
    </React.Fragment>
  );
}

InputField.propTypes = {
  name: PT.string,
  placeholder: PT.string,
  type: PT.string,
  value: PT.string,
  required: PT.bool
};
